import { useState } from 'react'

//Components
import Comment from './Comment'
import Flex from './utils/Flex'
import TWButton from './utils/TWButton/TWButton'
import ImagePreview from './ImagePreview/ImagePreview'
import TWTooltip from './utils/TWTooltip/TWTooltip'


const Post = ({ post } = { post: { user: {} } }) => {

	const [state, setState] = useState({
		likes: 22,
		comment: '',
		isLoved: false,
		imagePreview: false,
		isGhost: false,

	})
	const [comments, setComments] = useState([
		{
			ghost: false,
			text: `Lorem ipsum dolor
			sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod
			tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
			voluptua.`
		},
		{
			ghost: false,
			text: `Lorem ipsum dolor
			sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod
			tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
			voluptua.`
		}
	])

	const sendComment = () => {
		setComments(comments.concat({
			ghost: state.isGhost,
			text: state.comment
		}))
		setState({ ...state, comment: '' })
	}
	const onClickLove = () => {
		setState({
			...state,
			isLoved: !state.isLoved,
			likes: state.isLoved
				? state.likes - 1
				: state.likes + 1
		})
	}
	const onDoubleClickImage = () => {
		if (!state.isLoved) {
			setState({
				isLoved: true,
				likes: state.likes += 1
			})
		}
	}

	return (
		<div className="post bg-primary rounded relative p-3 lg:p-6 2xl:p-10">
			<p className="absolute top-3 right-3 lg:top-6 lg:right-6 2xl:top-6 2xl:right-10 font-bold text-xs lg:text-base text-cyan-accent">
				2 Days Ago
			</p>
			<Flex itemsEnd>
				<img
					alt="Profile thumbnail"
					src={post.user.thumbnail}
					className="w-14 h-14 lg:w-20 lg:h-20 2xl:w-28 2xl:h-28 rounded lg:rounded-xl object-cover object-center"
				/>
				<div className="ml-4">
					<h4 className="text-base lg:text-xl 2xl:text-2xl font-bold">
						{post.user.fullName}
					</h4>
					<p className="text-base lg:text-xl 2xl:text-2xl font-bold text-cyan-accent">
						{post.user.username}
					</p>
				</div>
			</Flex>
			{post.text && (
				<div className="bg-secondary rounded lg:rounded-xl text-base lg:text-xl p-3 mt-3 lg:mt-5">
					<p>{post.text}</p>
				</div>
			)}
			<div className="relative mt-3 lg:mt-5">
				{post.images.map((image, imageIndex) => (
					<img
						src={image}
						key={imageIndex}
						alt="Post thumbnail"
						className="w-full rounded lg:rounded-xl cursor-pointer"
						onDoubleClick={() => onDoubleClickImage()}
						onContextMenu={e => e.preventDefault()}
					/>
				))}
				<button
					onClick={() => setState({ ...state, imagePreview: post.images[0] })}
					className="absolute right-2 bottom-0 lg:right-4 lg:bottom-4"
				>
					<i className="material-icons md:text-3xl 2xl:text-4xl">zoom_in</i>
				</button>
			</div>
			<Flex justify-between items-center className="mt-5">
				<div className="flex items-stretch">
					<TWButton onClick={onClickLove} size="md" className="mr-4">
						{state.isLoved
							? <i className="material-icons text-red-500">favorite</i>
							: <i className="material-icons">favorite_border</i>
						}
					</TWButton>
					<TWButton size="md" className="text-cyan-accent hover:text-white">
						<span className="material-icons text-base lg:text-lg 2xl:text-2xl mr-2">chat_bubble</span>
						<span>Send Tip</span>
					</TWButton>
				</div>
				<div className="font-bold text-base lg:text-2xl">{state.likes} Likes</div>
			</Flex>
			<div className='mt-4'>
				{comments.map((com, comIndex) => (
					<Comment
						className="mt-5"
						key={comIndex}
						user={post.user}
						comment={com.text}
						ghost={com.ghost}
					/>
				))}
			</div>
			<hr className="my-4 border-t-2 border-secondary" />
			<div>
				<textarea
					name="commnent"
					value={state.comment}
					placeholder="Type a message"
					onChange={e => setState({ ...state, comment: e.target.value })}
					className="w-full bg-transparent text-base 2xl:text-xl"
				/>
				<div className="flex justify-end space-x-4">
					<button className="bg-cyan-500 items-center flex space-x-2 py-1 lg:py-2 px-4">
						<span
							className="flex space-x-2"
							onClick={() => setState({ ...state, isGhost: !state.isGhost })}
						>
							<svg width="16.968" height="22.624">
								<path
									fill="#fff"
									data-name="Icon awesome-ghost"
									d="M8.223 0A8.72 8.72 0 000 8.84V20.5a.707.707 0 001.207.5l1.1-.819a.707.707 0 01.95.1l1.9 2.136a.707.707 0 001 0l1.8-2.026a.707.707 0 011.057 0l1.8 2.026a.707.707 0 001 0l1.9-2.136a.707.707 0 01.95-.1l1.1.819a.707.707 0 001.207-.5V8.484A8.484 8.484 0 008.223 0zM5.656 9.9A1.414 1.414 0 117.07 8.484 1.414 1.414 0 015.656 9.9zm5.656 0a1.414 1.414 0 111.414-1.414A1.414 1.414 0 0111.312 9.9z"
								/>
							</svg>
							<span>Ghost {state.isGhost ? "On" : "Off"}</span>
						</span>
						<TWTooltip text={`Ghost mode ${state.isGhost ? 'enabled' : 'disabled'}`}>
							<svg width="16" height="16">
								<path
									fill="#fff"
									data-name="Icon ionic-ios-information-circle"
									d="M8 0a8 8 0 108 8 8 8 0 00-8-8zm.731 11.692H7.262V6.15h1.469zm-.735-6.146a.768.768 0 11.8-.769.771.771 0 01-.8.769z"
								/>
							</svg>
						</TWTooltip>
					</button>
					<button
						onClick={sendComment}
						className="bg-secondary2 py-1 lg:py-2 px-4"
					>
						Send
					</button>
				</div>
			</div>
			<ImagePreview
				value={state.imagePreview}
				onClose={() => setState({ ...state, imagePreview: false })}
			/>
		</div>
	)
}

export default Post